import gql from 'graphql-tag';

export const GetAllRates = gql`
  query getAllRates {
    rates {
      name
      rate
      id
      createdAt
    }
  }
`;

export const CreateRateMutation = gql`
  mutation createNewRate($name: String, $rate: Float) {
    createrate(name: $name, rate: $rate) {
      name
      rate
      id
      createdAt
    }
  }
`;

export const DeleteRateMutation = gql`
  mutation deleteRate($id: Int!) {
    deleterate(id: $id) {
      success
      message
    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/Rates/query.js